import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  attendanceFilterList,
  attendanceFilterCard,
  themes,
} from "services/constants";
import { showToast } from "services/utils/Status";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { Device } from "components/Navbars/DeviceStatus";
import { ListView } from "./ListView";
import { CardView } from "./CardView";
import { AddDepartment } from "./AddDepartment";
import { setReloadHRMSApi } from "services/Redux/leaveManagement";
import {
  setDepartmentId,
  setDepartmentName,
  setDepartmentLeadId,
  setShiftCategoryId,
} from "services/Redux/userManagament";

import { Loader } from "components/Loader";
import sessionHandling from "services/utils/notificationUtils";
let designColor = "#0C8CE9";
export const AttendanceStatus = ({
  shiftId,
  date,
  setReloadAPIForCard,
  reloadAPIForCard,
  userDataViewMethod,
  setDeviceOffline,
  deviceOffine,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const { token, domain, globalSearchValue, userDetails, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);

  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentApi, setDepartmentApi] = useState(true);
  const [allDepartmentDetails, setAllDepartmentDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [listViewPage, setListViewPage] = useState(0);
  const [Page, setLeavePage] = useState(0);

  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  useEffect(() => {
    if (reloadAPIForCard) {
      setDepartmentApi(true);
      setReloadAPIForCard(false);
    }
  }, [reloadAPIForCard, setReloadAPIForCard]);

  useEffect(() => {
    if (topbarCompanyId) {
      setDepartmentApi(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchTeam = async () => {
      setLoader(true);
      try {
        const response = await fetch(
          `${domain}department/details?user_id=${userDetails.id}&company_id=${topbarCompanyId}&shift_id=${shiftId}&date=${date}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          if (response.status === 202) {
            setDeviceOffline(true);
          } else {
            setMasterDataForSearch(res.departments);
            setDepartmentList(res.departments);
            setAllDepartmentDetails(res.all);
            setDeviceOffline(false);
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
      setLoader(false);
    };
    if (departmentApi) {
      fetchTeam();
      setDepartmentApi(false);
    }
  }, [
    date,
    departmentApi,
    domain,
    setDeviceOffline,
    shiftId,
    token,
    topbarCompanyId,
    userDetails.id,
  ]);

  useEffect(() => {
    let filterKeys =
      userDataViewMethod === "CardView"
        ? attendanceFilterCard
        : attendanceFilterList;
    const filteredResults = masterDataForSearch?.filter((item) =>
      filterKeys?.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setDepartmentList(filteredResults);
    setListViewPage(0);
    setLeavePage(0);
  }, [globalSearchValue, masterDataForSearch, userDataViewMethod]);

  const handleNavigate = () => {
    dispatch(setGlobalSearchValue(""));
    dispatch(setDepartmentId(99999));
    dispatch(setDepartmentLeadId(99999));
    dispatch(setDepartmentName("All"));
    dispatch(setShiftCategoryId(99999));
    localStorage.setItem("approveLeaveDepartmentId", "99999");
    localStorage.setItem("approveLeaveDepartmentName", "All");
    dispatch(setReloadHRMSApi(false));
    history.push("/admin/teamzone/attendances/status");
  };

  return loader ? (
    <Loader info="Loading..." />
  ) : deviceOffine ? (
    <Device />
  ) : (
    <React.Fragment>
      {open ? (
        <AddDepartment
          open={open}
          setOpen={setOpen}
          setDepartmentApi={setDepartmentApi}
        />
      ) : null}
      <Mui.Grid container>
        <Mui.Grid
          container
          spacing={2}
          sx={{
            px: { xs: 2, sm: 4, md: 6, lg: 7 },
            marginTop: 1,
            alignItems: "center",
            pointerEvents:
              allDepartmentDetails?.total_staff_count === 0 ? "none" : "auto",
            opacity: allDepartmentDetails?.total_staff_count === 0 ? 1 : 1,
          }}
          onClick={() => {
            handleNavigate();
          }}
        >
          <Mui.Grid
            xs={1.6}
            component={Mui.Paper}
            elevation={1}
            sx={{ padding: 4.5 }}
          >
            <Mui.Grid container justifyContent="center" alignItems="center">
              <Mui.Typography
                sx={{
                  color: designColor,
                  fontWeight: "bold",
                  fontSize: 18,
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
              >
                All Department
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid container justifyContent="center" alignItems="center">
              <Mui.Typography
                sx={{
                  color: themes.headeLine,
                  fontWeight: "bold",
                  fontSize: 18,
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {allDepartmentDetails?.total_staff_count}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid xs={0.1}></Mui.Grid>
          <Mui.Grid xs={10}>
            <Mui.Grid
              container
              component={Mui.Paper}
              elevation={1}
              sx={{ padding: 0.5 }}
            >
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Present
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_present_count}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Absent
                </Mui.Typography>{" "}
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_absent_count}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Late / Early
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_late_early}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Over time
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_overtime_count}
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ padding: 0.5 }}></Mui.Grid>
            <Mui.Grid
              container
              component={Mui.Paper}
              elevation={1}
              sx={{ padding: 0.5 }}
            >
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Planned
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_planned_count}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Leave{" "}
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_leave_count}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}>
                <Mui.Typography
                  sx={{
                    textAlign: "center",
                    color: designColor,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Week off
                </Mui.Typography>
                <Mui.Typography
                  sx={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}
                >
                  {allDepartmentDetails?.staff_weekoff_count}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={3}></Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid xs={0.3}></Mui.Grid>
        </Mui.Grid>
      </Mui.Grid>
      {userDataViewMethod === "ListView" ? (
        <ListView
          departmentList={departmentList}
          setDepartmentList={setDepartmentList}
          listViewPage={listViewPage}
          setListViewPage={setListViewPage}
          masterDataForSearch={masterDataForSearch}
        />
      ) : (
        <CardView
          departmentList={departmentList}
          setLeavePage={setLeavePage}
          Page={Page}
          masterDataForSearch={masterDataForSearch}
        />
      )}
    </React.Fragment>
  );
};
